import { render, staticRenderFns } from "./TicketPlaceOrder.vue?vue&type=template&id=62452d22&scoped=true"
import script from "./TicketPlaceOrder.vue?vue&type=script&lang=js"
export * from "./TicketPlaceOrder.vue?vue&type=script&lang=js"
import style0 from "./TicketPlaceOrder.vue?vue&type=style&index=0&id=62452d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62452d22",
  null
  
)

export default component.exports